module.exports = __webpack_public_path__ + "img/home-jump3.5561c90d.png";